/* eslint-disable max-len */
import { motion } from 'framer-motion'
import React from 'react'
import { Link } from 'react-router-dom'

export default function OfferListing({list,responsivePopup}) {
    return (
        <div className="pb-5 pt-8" >
            {list?.length>0 && list.map((offer)=>(
                <motion.div
                    animate={{ opacity: 1, x: 0 }}
                    initial={{ opacity: 0, x: -10 }}
                    exit={{ opacity: 0, x: -10 }}
                    transition={{ duration: 0.15 }}  className="" key={offer?.composit_key} >
                    <div className="w-full rounded-[10px] shadow-s7 p-2.5 mb-2">
                        <div>
                            <ul className="flex relative justify-end items-center sm:flex-col flex-row">
                                <li>
                                    <motion.button
                                        initial={{ opacity: 0, scale: 0.5 }}
                                        animate={{ opacity: 1, scale: 1 }}
                                        transition={{
                                            duration: 0.8,
                                            delay: 0.5,
                                            ease: [0, 0.71, 0.2, 1.01]
                                        }}  type="button"
                                        className="text-xs font-semibold text-[#FFFFFF] bg-[#44445E] rounded px-1.5 py-1 w-fit absolute right-12 top-2">
                                        {offer?.offer_type}</motion.button>
                                </li>
                                <li>
                                    <motion.button
                                        initial={{ opacity: 0, scale: 0.5 }}
                                        animate={{ opacity: 1, scale: 1 }}
                                        transition={{
                                            duration: 0.8,
                                            delay: 0.5,
                                            ease: [0, 0.71, 0.2, 1.01]
                                        }}  type="button" className="text-xs font-semibold text-[#FFFFFF] bg-[#44445E] rounded px-1.5 py-1 w-fit absolute right-2 top-2">{offer?.industrial_pocket}</motion.button>
                                </li>
                            </ul>
                            <div className="">
                                <div className="flex items-center justify-between mt-5 md:flex-nowrap flex-wrap">
                                    <div className="flex items-center sm:flex-nowrap flex-wrap">
                                        <motion.img
                                            className="box"
                                            initial={{ opacity: 0, scale: 0.5 }}
                                            animate={{ opacity: 1, scale: 1 }}
                                            transition={{
                                                duration: 0.8,
                                                delay: 0.5,
                                                ease: [0, 0.71, 0.2, 1.01]
                                            }}
                                            src="images/related-offer.svg" alt="icon"/>
                                        <div className="pl-5 w-full">
                                            <ul className="sm:mt-0 mt-2">
                                                <li className="font-semibold text-base text-[#090406]">{offer?.offer_code}</li>
                                                <li className="text-[#44445E] font-normal text-xs13 my-[7px]">Validity: <span className="font-semibold text-[#44445E] text-xs13">{offer?.start_date.split("-").reverse().join("-")?.replace(/-/g,'/')} - {offer?.end_date?.split("-").reverse().join("-").replace(/-/g,'/')}</span><span className="px-2">|</span><span className="font-semibold text-[#44445E] text-xs13">{offer?.offer_value}</span>{ offer?.offer_type === 'Special' && ( <><span className="px-2">|</span><span className="font-semibold text-[#44445E]">{offer?.dap_config === true ? 'DAP Applicable' : 'FOR' || 'DAP Applicable'} </span><span>|</span><span className="font-semibold text-[#44445E] text-xs13 ml-1">{offer?.trade_eub === true ? 'Trade EUB Applicable' : ''}</span></>)}</li>
                                                <li className="text-[#44445E] font-normal text-xs2" style={{maxWidth:'500px',flexWrap:'wrap'}}>{offer?.description}</li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="flex items-center justify-end lg:mt-10 mt-5 sm:ml-0 ml-5 self-end">
                                        <Link to={offer?.offer_type === "Special" || offer?.offer_type === 'Standard' ? `/offers/${offer.offer_code.split('/').join('-')}?code=${encodeURIComponent(offer.offer_code)}` :`/special-recurring-offers/${offer.offer_code.split('/').join('-')}?code=${encodeURIComponent(offer.offer_code)}`}>
                                            <motion.button
                                                initial={{ opacity: 0, scale: 0.9 }}
                                                animate={{ opacity: 1, scale: 1 }}
                                                transition={{
                                                    duration: 0.8,
                                                    delay: 0.5,
                                                    ease: [0, 0.71, 0.2, 1.01]
                                                }} type="button" className="sm:w-[284px] w-[170px] h-10 rounded-lg bg-[#555259] font-semibold text-sm text-[#FFFFFF]">
                                                View Offer
                                            </motion.button>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </motion.div>
            ))}
        </div>
    )
}
